export const query_importMapping_byTenant = `
query getLastActivityByUserId($tenantId: String!, $aziendaId: Int!) {
    import_mapping(where: { TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}}) {
        Id
        TenantId
        AziendaId
        Type
        MappedValue
        Value
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
    }
}`;